import { Button, Flex, Table, message } from 'antd';

import {
	useAddCreatorToCreatorsCollection,
	useDeleteCreatorFromCollection,
} from '@/api/monitor_collections';
import Loader from '@/layouts/loaders/loading';
import { ICreatorCollectionItem } from '@/ts';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading: boolean;
	isFetching?: boolean;
	pagination: any;
	setPagination: any;
	creator: {
		creator_mongo_id: string;
		url: string;
		tags: [];
	};
};

export default function AddRemoveCreatorsCollectionsTable({
	data,
	columns,
	onTableChange,
	isLoading,
	pagination,
	setPagination,
	creator,
}: TProps) {
	const { mutate: addCreator, isLoading: isAddLoading } =
		useAddCreatorToCreatorsCollection();

	const { mutate: deleteCreator, isLoading: isDeleteLoading } =
		useDeleteCreatorFromCollection();

	// const { mutate: deleteCollection, isLoading: isDeleteLoading } =
	//   useDeleteSingleCollection("creators");

	const onAddClick = (id: number) => {
		addCreator(
			{
				creator_mongo_id: creator?.creator_mongo_id,
				url: creator?.url,
				tags: creator?.tags || [],
				collection_id: id,
			},
			{
				onSuccess: () => {
					message.success('Added');
				},
				onError: (error) => {
					const err = error as any;
					message.error(
						`An error occured: ${
							err?.response?.data?.message || err?.message
						}.`,
					);
					console.error('error', error);
				},
			},
		);
	};

	const onDeleteClick = (collection_id: number, record_id: number) => {
		deleteCreator(
			{
				collection_id,
				id: record_id,
			},
			{
				onSuccess: () => {
					message.success('Removed');
				},
				onError: (error) => {
					const err = error as any;
					console.error(
						'Error deleting collection:',
						err.response.data.message,
					);
					message.error(err.response.data.message);
				},
			},
		);
	};

	return (
		<Table
			size="small"
			// dataSource={data?.data?.data?.results}
			dataSource={data}
			columns={[
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					width: 100,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: ICreatorCollectionItem) => {
						const searchedItem = record?.creators_list?.find(
							(rec) => rec?.creator_mongo_id === creator?.creator_mongo_id,
						);

						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								{searchedItem ? (
									<Button
										size="small"
										style={{ minWidth: '60px' }}
										danger
										onClick={() =>
											onDeleteClick(
												searchedItem?.user_creators_collection_id,
												Number(searchedItem?.id),
											)
										}
										disabled={!creator?.creator_mongo_id}
									>
										Remove
									</Button>
								) : (
									<Button
										size="small"
										style={{ minWidth: '60px' }}
										// type="primary"
										// variant="outlined"
										onClick={() => onAddClick(Number(record?.id))}
										disabled={!creator?.creator_mongo_id}
									>
										Add
									</Button>
								)}
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			rowClassName="editable-row"
			rowKey={'id'}
			onChange={onTableChange}
			loading={isLoading || isDeleteLoading || isAddLoading}
			bordered
			pagination={{
				total: pagination?.total,
				pageSize: pagination?.limit,
				current: pagination?.page,
				// pageSizeOptions: [5, 10],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
